import { render } from "./EmailPhone.vue?vue&type=template&id=52cab2b8"
import script from "./EmailPhone.vue?vue&type=script&lang=js"
export * from "./EmailPhone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__